import Input from 'components/input';
import styles from './styles.module.scss';
import React from 'react';
import Button from 'components/button';
import request from 'request';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';

export default function ModalUpdateSum({ onClose }: { onClose: () => void }) {
  const [sum, setSum] = React.useState('');
  const [sumError, setSumError] = React.useState('');
  const [pending, setPending] = React.useState(false);

  const dispatch = useDispatch();

  const { id } = useParams();

  const handleUpdateSum = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!sum.trim()) {
      return setSumError('Обязательное поле');
    }
    setPending(true);
    request
      .put(`/applications_gold/${id}/amount`, {
        amount: sum,
      })
      .catch((e) => {
        toast.error(e.message);
      })
      .finally(() => {
        setPending(false);
        toast.success('Сумма обновлена');
        setTimeout(() => dispatch.applicationCollateral.FETCH_APPLICATION_BY_ID(id), 1000);
        onClose();
      });
  };

  return (
    <div className={styles.modal} onMouseDown={onClose}>
      <div className={styles.container}>
        <form
          className={styles.modal_wrap}
          onMouseDown={(event) => event.stopPropagation()}
          onSubmit={handleUpdateSum}
        >
          <div className={styles.title}>Обновить сумму</div>
          <div className={styles.input}>
            <Input
              title="Сумма"
              type="integer"
              value={sum}
              onInput={(value) => {
                setSumError('');
                setSum(value);
              }}
              step={100}
              min={500}
              max={30000}
              placeholder={'мин: 500 макс: 30000'}
              unit="TJS"
              error={sumError ? sumError : ''}
            />
          </div>
          <div className={styles.buttonGroup}>
            <Button color="orange" onClick={onClose}>
              Отмена
            </Button>
            <Button type="submit" color="green" pending={pending}>
              Обновить
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
